import React, { useState, useEffect } from 'react';






const FooterPart = () => {
    return (
        <footer className="">
            <div className="has-text-centered">
                <p style={{ fontSize: '11px', color: '#969696' }}>
                    <strong>SOFTBERRY Dawid Janus dla PZM</strong> © 2026 ver. 1.0 BETA
                </p>
            </div>
        </footer>
    );
};
export default FooterPart;
